// extracted by mini-css-extract-plugin
export default {"footerButton":"bVtkT","iconContainer":"SwzLF","iconSuccess":"pM_9n","success-icon":"UWYIU"};